module.exports = __webpack_public_path__ + "static/media/ledlamp.6199e14a.png";